export const weightUnitOptions = [
  // {label: 'Milligram (mg)', value: 'mg'},
  {label: 'Gram (g)', value: 'g'},
  {label: 'Kilogram (kg)', value: 'kg'},
  {label: 'Metric Ton (t)', value: 't'},
  // {label: 'Ounce (oz)', value: 'oz'},
  // {label: 'Pound (lb)', value: 'lb'},
  // {label: 'Stone (st)', value: 'st'},
  // {label: 'Short Ton (US) (short_ton)', value: 'short_ton'},
  // {label: 'Long Ton (UK) (long_ton)', value: 'long_ton'},
  // {label: 'Carat (ct)', value: 'ct'},
  // {label: 'Grain (gr)', value: 'gr'},
  // {label: 'Quintal (q)', value: 'q'},
  {label: 'Liter' , value: 'l'},
  {label: 'Milliliter' , value: 'ml'}
];
